var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Select',{attrs:{"options":_vm.srtOptions,"value":_vm.srt},on:{"change":_vm.onSrtChange}})}
var staticRenderFns = []

export { render, staticRenderFns }